export default __webpack_public_path__ + "static/media/miguel-lopes-25.3fa29fee.jpg";